import { useEffect } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';

/**
 * Basic LogRocket identification hook for use at the top level
 * where AuthProvider context may not be available
 */
export const useBasicLogRocketIdentification = () => {
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    console.log('[LogRocket] Basic hook - authentication state changed:', {
      isAuthenticated,
      isDev: import.meta.env.DEV,
      logRocketActive: !import.meta.env.DEV,
      timestamp: new Date().toISOString()
    });
    
    if (import.meta.env.DEV) {
      console.log('[LogRocket] Running in development mode - LogRocket disabled');
      return;
    }
    
    if (isAuthenticated) {
      console.log('[LogRocket] User authenticated but identification will be handled by LogRocketAuthIdentifier component');
    } else {
      console.log('[LogRocket] User not authenticated - tracking anonymously');
    }
  }, [isAuthenticated]);
}; 